import cn from 'clsx'
import { NavLink } from 'react-router'

import { blogCategoryBySlug } from '@/utils/blogCategories'
import { BlogCategory } from '@/utils/types'

type Props = {
  activeClassName?: boolean
  category: BlogCategory
  className?: string
}

export default function BlogCategoryLink({ activeClassName, category, className }: Props) {
  const { label, activeClassName: active, inactiveClassName: inactive } = blogCategoryBySlug[category]

  return (
    <NavLink
      className={({ isActive }) => cn(className, activeClassName && isActive ? active : inactive)}
      prefetch='intent'
      to={`/blog/category/${category}`}
    >
      {label}
    </NavLink>
  )
}
